export enum CertificateStatus {
  Valid = 'Valid',
  Invalid = 'Invalid',
  Unknown = 'Unknown',
}
